import React, { useRef, useState, useEffect } from "react";
import "../../../styles/StorePerf.css";
import { useNavigate } from "react-router-dom";
import {
  useFetchQueTypes,
  useFetchAudCycles,
} from "../../../utils/hooks/UseFetchUrl";
import { Button, Input, Spin } from "antd";
import axios from "axios";
import { base_url } from "../../../utils/apiConfig";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import newStyled from "@emotion/styled";

const StorePerformance = () => {
  const { data: queTypesData, isLoading } = useFetchQueTypes(
    "/questionnaire_types_for_dashboard",
  );
  const { data: cyclesData } = useFetchAudCycles("/audit_cycle_for_dashboard");
  const queId = queTypesData?.[0]?.id;
  const [selectedQueId, setSelectedQueId] = useState(null);
  const [percentage, setPercentage] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [sections, setSections] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const ref = useRef();
  const [searchPerformed, setSearchPerformed] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, [cyclesData, selectedQueId]);

  useEffect(() => {
    if (queId) {
      setSelectedQueId(queId);
    }
  }, [queId]);

  const onSearch = async () => {
    if (!percentage) {
      // Bail out before setting loading, or the table stays on "Searching...".
      alert("Please enter a valid percentage without using % sign");
      return;
    }
    setLoading(true);
    setSearchPerformed(true);
    const authToken = localStorage.getItem("authToken");
    console.log("Search Value:", percentage);
    if (percentage && selectedQueId) {
      try {
        const payload = {
          percentage: percentage,
          questionnaire_id: selectedQueId,
        };
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${authToken}`,
          },
        };
        const response = await axios.post(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store_performance`,
          payload,
          config,
        );
        if (
          response.data.section_count &&
          Array.isArray(response.data.section_count)
        ) {
          setSearchResults(response.data.section_count || []);
          localStorage.setItem(
            "searchResults",
            JSON.stringify(response.data.section_count),
          );
          localStorage.setItem("percentage", percentage);
        } else {
          console.log(
            "Expected an array for section_count, got:",
            response.data.section_count,
          );
          setSearchResults([]);
          localStorage.removeItem("searchResults");
          localStorage.removeItem("percentage");
        }
        if (response.data.sections && Array.isArray(response.data.sections)) {
          const updatedSections = response.data.sections.map((sec) => ({
            ...sec,
            percentage: percentage,
          }));

          setSections(updatedSections);
          localStorage.setItem("sections", JSON.stringify(updatedSections));
        } else {
          console.log(
            "Expected an array for sections, got:",
            response.data.sections,
          );
          setSections([]);
          localStorage.removeItem("sections");
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const regex = /^(\d+(\.\d{1,2})?)$/;
    const numberValue = parseFloat(value);
    if (
      (regex.test(value) && numberValue >= 1 && numberValue <= 100) ||
      value === ""
    ) {
      setPercentage(value);
    }
    if (value === "") {
      setSearchPerformed(false);
      setSearchResults([]);
    }
  };

  useEffect(() => {
    if (queId) setSelectedQueId(queId);
  }, [queId]);

  const handleSelectChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    setSelectedQueId(selectedId);
    localStorage.removeItem("searchResults");
    localStorage.removeItem("percentage");
    setSearchResults([]);
    setPercentage("");
  };

  const handleModalOpen = async (row, sec) => {
    if (sec?.count > 0) {
      const auditCycleId = sec?.audit_cycle_id || "1361";
      const percentage =
        row?.percentage ||
        sec?.percentage ||
        localStorage.getItem("percentage") ||
        "50";
      const sectionId = sec?.section_id || "11522";

      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.post(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store_performance_store_list_by_percentage`,
          {
            audit_cycle_id: auditCycleId.toString(),
            percentage: percentage,
            section_id: sectionId.toString(),
          },
          {
            headers: {
              Authorization: `token ${authToken}`,
            },
          },
        );
        setModalData(response.data);
        ref.current.click();
      } catch (error) {
        console.log("Error hitting POST API", error);
      }
    } else {
      console.warn(
        "Section count is not greater than 0 or section data is missing",
      );
    }
  };

  const handleInsights = (storeId) => {
    const token = localStorage.getItem("authToken");
    fetch(
      `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${storeId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        navigate(`/storeBrowserInsights/${storeId}`, {
          state: { storeData: data },
        });
        window.location.href = `/storeBrowserInsights/${storeId}`;
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
      });
  };

  return (
    <div className="minHtForTbl m-3">
      <button
        ref={ref}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        Launch demo modal
      </button>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "900px" }}
        >
          <div
            style={{ backgroundColor: "#F6F6F6" }}
            className="modal-content p-2"
          >
            <div className="modal-header" style={{ border: "none" }}>
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Store List of {modalData?.audit_cycle_name} -{" "}
                {modalData?.section_name}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <table
                className="mx-auto"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead className="store-modal-table">
                  <tr>
                    <th className="align-center1">Sr. No.</th>
                    <th className="align-center1">Store Code</th>
                    <th className="align-center1 showroomTable">
                      Showroom Name
                    </th>
                    <th>City</th>
                    <th>Insights</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData?.store_list?.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                      }}
                    >
                      <td className="align-center  snum">{index + 1}</td>
                      <td className="align-center  scode">{row.code || "N/A"}</td>
                      <td className="align-justify sname">{row.name}</td>
                      <td className="align-center">{row.city}</td>
                      <td className="align-center inbtn">
                        <button
                          onClick={() => handleInsights(row.id)}
                          className="viewPerBtn"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="perf-head text-start my-3">
        <p className="sp">Store performance benchmarking</p>
      </div>
      <div className="row align-items-center">
        <div className="col-md-3 col-12 d-flex flex-wrap align-items-center gap-2">
          <p className="mb-0 SpQuesHeading">Questionnaire Type:</p>
          <select
            onChange={handleSelectChange}
            disabled={isLoading}
            className="selectStorePer"
          >
            {isLoading ? (
              <option style={{ color: "#003d51" }}>Loading...</option>
            ) : (
              queTypesData?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))
            )}
          </select>
        </div>
        <div className="col-md-4 col-12 d-flex flex-wrap align-items-center gap-2 mt-2 mt-md-0">
          <p className="mb-0 SpQuesHeading">Percentage:</p>
          <div className="audit-cycle-inp">
            <SearchStyle
              placeholder="Enter percentage"
              allowClear
              enterButton={
                <Button
                  type="primary"
                  loading={loading}
                  style={{ backgroundColor: "#007dc1" }}
                >
                  {loading ? (
                    <div style={{ fontSize: "1rem" }}>
                      <Spin indicator={<LoadingOutlined spin />} size="small" />
                      Searching
                    </div>
                  ) : (
                    <div style={{ fontSize: "1rem", fontFamily: "Roboto" }}>
                      Search
                      <SearchOutlined
                        size={"small"}
                        style={{ marginLeft: "4px" }}
                      />
                    </div>
                  )}
                </Button>
              }
              size="medium"
              onSearch={onSearch}
              onChange={handleInputChange}
              inputMode="decimal"
              maxLength={6}
              value={percentage}
            />
          </div>
        </div>
      </div>
      <div className="perf-lower my-3">
        <div className="table-bordered table-responsive">
          <table id="table-to-export" className="custom-table-row">
            <thead>
              <tr>
                <th className="SNO align-center" style={{ width: "5vw" }}>
                  Sr. No.
                </th>
                <th
                  className="audit align-center"
                  style={{ minWidth: "270px" }}
                >
                  Audit
                </th>
                <th
                  className="audit align-center"
                  style={{ minWidth: "100px" }}
                >
                  No. of Audits
                </th>
                {sections.map((section, index) => (
                  <th key={index} className="align-center">
                    {section.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="100%" className="text-center">
                    Searching...
                  </td>
                </tr>
              ) : searchResults.length === 0 && !searchPerformed ? (
                <td colSpan="100%" className="showTblText">
                  Use this dashboard to get stores which have scored less than
                  optimal value. You can enter the optimal value in the input
                  box above between 1-100
                </td>
              ) : !searchPerformed ? (
                <tr>
                  <td colSpan="100%" className="text-center showTblText">
                    Use this dashboard to get stores which have scored less than
                    optimal value. You can enter the optimal value in the input
                    box above between 1-100
                  </td>
                </tr>
              ) : searchResults.length === 0 && searchPerformed ? (
                <tr>
                  <td colSpan="100%" className="text-center">
                    No result found, try another value.
                  </td>
                </tr>
              ) : (
                searchResults.map((row, index) => (
                  // <tr key={index} >
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? "rgb(242,242,242)" : "#ffffff",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        index % 2 === 0 ? "#ffffff" : "rgb(242,242,242)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        index % 2 === 0 ? "rgb(242,242,242)" : "#ffffff")
                    }
                  >
                    <td className="SrNo">{index + 1}</td>
                    <td>{row?.audit_cycle || "No Data Available"}</td>
                    <td className="count">
                      {row?.total_audit_store_count || 0}
                    </td>
                    {Array.isArray(row.section) &&
                      row.section.map((sec, secIndex) => (
                        <td key={secIndex} className="marks">
                          <div
                            onClick={() => {
                              if (sec?.count >= 1) {
                                handleModalOpen(row, sec);
                              }
                            }}
                            className={`row-marks mx-auto df ${
                              sec?.count !== 0
                                ? "highlight cursor-pointer"
                                : "cursor-default"
                            }`}
                          >
                            {sec?.count || 0}
                          </div>
                        </td>
                      ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const SearchStyle = newStyled(Input.Search)`
   .ant-input-search :where(.css-dev-only-do-not-override-1kf000u).ant-input-group .ant-input-affix-wrapper:not(:last-child) {
     border-radius : 4px !important;
   }

   :where(.css-dev-only-do-not-override-1kf000u).ant-input-search .ant-input-affix-wrapper{
   border-start-end-radius: 5px !important;
    border-end-end-radius:5px !important;
   }

   :where(.css-dev-only-do-not-override-1kf000u).ant-input-search >.ant-input-group >.ant-input-group-addon:last-child{
   inset-inline-start: 0.8rem !important;
    padding: 0 !important;
    border: none !important;
   }

   :where(.css-dev-only-do-not-override-1kf000u).ant-input-search >.ant-input-group >.ant-input-group-addon:last-child .ant-input-search-button{
   border-start-start-radius: 5px !important;
    border-end-start-radius:  5px !important; 
   }
`;

export default StorePerformance;
